import httpHelper from "@/helpers/httpHelper";
// action types
export const GET_GATEWAY_LIST = "getGatewayList"; 
export const SEND_INTERNAL_TRANSFER = "sendInternalTransfer"; 

//mutation types
export const SET_GATEWAY_LIST = "setGatewayList";
// export const SET_SEND_INTERNAL_TRANSFER = "setSendInternalTransfer";

export default {
    state: {
        
        listGateway:[],
        
    },
    getters: {
        /**
         * loade list of Gateway
         * @param state
         * @returns {*}
         */
        loadedlistGateway(state) {
            return state.listGateway;
        },
    },
    actions: {
       
        
        /**
         * Set the create listCheckout
         * @param state
         * @param payload
         */
         [GET_GATEWAY_LIST](context,payload) {
            
            return new Promise((resolve, reject) => {
            httpHelper
                .getData('share/gateways',payload)
                .then((response) => {
                    context.commit(SET_GATEWAY_LIST,response.result)
                    resolve(response)
                }).catch((error) => {
                    reject(error)
                })
            });
        },
        /**
         * send request for internal transfer
         * @param state
         * @param payload
         */
         [SEND_INTERNAL_TRANSFER](context,payload) {
            
            return new Promise((resolve, reject) => {
            httpHelper
                .postData('share/internal_transfer',payload)
                .then((response) => {
                    // context.commit(SET_SEND_INTERNAL_TRANSFER,response.result)
                    resolve(response)
                }).catch((error) => {
                    reject(error)
                })
            });
        },
    },
    mutations: {
       
        [SET_GATEWAY_LIST](state, payload) {
            state.listGateway = payload
        }
    }
};